import { render, staticRenderFns } from "./ai-chats.vue?vue&type=template&id=6c6b7849&scoped=true&"
import script from "./ai-chats.vue?vue&type=script&lang=js&"
export * from "./ai-chats.vue?vue&type=script&lang=js&"
import style0 from "./ai-chats.vue?vue&type=style&index=0&id=6c6b7849&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b7849",
  null
  
)

export default component.exports